module.exports = __webpack_public_path__ + "images/emoji/vibration_mode.0cc64d97da27096654ac.png";